import type { gcpProject } from '../types/gcpProject'

export type GcpProjectTableItem = gcpProject & {
	gcpProjectName: string
	platformName: string
}

export type GcpProjectTagsData = {
	body?: Array<{
		details?: {
			projectName?: string
			platformName?: {label: string, value: string}
		}
	}>
}

const getCreationTime = (project: gcpProject) => {
	const creationTime = Date.parse(project?.creationTime || '')

	return Number.isNaN(creationTime) ? 0 : creationTime
}

export const getSortedGcpProjectTableItems = (
	projects: gcpProject[] = [],
	tagResponses: Array<GcpProjectTagsData | undefined> = []
): GcpProjectTableItem[] =>
	projects
		.map((project, index) => ({
			...project,
			gcpProjectName: tagResponses[index]?.body?.[0]?.details?.projectName || '',
			platformName: tagResponses[index]?.body?.[0]?.details?.platformName?.label || ''
		}))
		.sort((a, b) => getCreationTime(b) - getCreationTime(a))
